/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_EnrollmentResponse = {
    billing_type?: courses_EnrollmentResponse.billing_type;
    cancelled_at?: string;
    child_firstname?: string;
    child_id?: string;
    child_lastname?: string;
    course_name?: string;
    course_plan_id?: string;
    created_at?: string;
    end_date?: string;
    enrollment_type?: string;
    id?: string;
    start_date?: string;
};
export namespace courses_EnrollmentResponse {
    export enum billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
}

